import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "72",
  height: "72",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "72",
      height: "72",
      fill: "#00C47D",
      rx: "36"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M32.938 49.563q1.25 0 1.921-1.016L48.734 27.03a3.2 3.2 0 0 0 .344-.718q.11-.344.11-.657 0-.843-.532-1.375-.53-.531-1.375-.531-.594 0-1 .234-.39.235-.75.797L32.875 44.86l-6.5-8.28q-.657-.86-1.625-.86-.86 0-1.422.547-.547.546-.547 1.375 0 .374.14.734.142.344.454.719l7.64 9.5q.797.969 1.922.968Z"
    }, null, -1)
  ])))
}
export default { render: render }